import { motion } from "framer-motion";
import { Compass, Lightbulb, Hammer, LineChart, Rocket } from "lucide-react";

const STEPS = [
  {
    icon: Compass,
    title: "Discover",
    desc: "Deep audit of your business, market, customer and funnel.",
  },
  {
    icon: Lightbulb,
    title: "Strategy",
    desc: "Custom growth blueprint tied to your unit economics.",
  },
  {
    icon: Hammer,
    title: "Build",
    desc: "Premium site, branding and content engineered to convert.",
  },
  {
    icon: LineChart,
    title: "Optimize",
    desc: "SEO, GEO and CRO testing to compound performance.",
  },
  {
    icon: Rocket,
    title: "Grow",
    desc: "Scale channels, leads and revenue — month over month.",
  },
];

export default function Process() {
  return (
    <section data-testid="process-section" className="section relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-300 text-xs font-semibold tracking-widest uppercase">
            How We Work
          </div>
          <h2 className="mt-5 font-display text-4xl md:text-5xl font-bold tracking-tight">
            A proven 5-step growth process.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`process-step-${i}`}
                className="group relative rounded-2xl border border-white/10 bg-white/[0.025] p-6 hover:border-cyan-500/30 hover:bg-white/[0.04] transition-all duration-300"
              >
                <div className="flex items-center justify-between mb-5">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-600 to-cyan-400 flex items-center justify-center shadow-[0_8px_20px_rgba(0,229,255,0.2)]">
                    <Icon className="w-5 h-5 text-black" />
                  </div>
                  <span className="font-display text-3xl font-extrabold text-white/15">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-display text-xl font-semibold text-white">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-white/60 leading-relaxed">
                  {s.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
